import { api } from './api';

export interface Vendor {
  _id: string;
  name: string;
  address: string;
  contactPerson: string;
  email: string;
  phone: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface VendorFormData {
  name: string;
  address: string;
  contactPerson: string;
  email: string;
  phone: string;
}

export interface VendorResponse {
  data: {
    result: Vendor[];
    totalCount: number;
    currentPage: number;
    totalPages: number;
    previousPage: number | null;
    nextPage: number | null;
  };
  message: string;
  error: boolean;
}

export interface CreateVendorResponse {
  data: Vendor;
  message: string;
  error: boolean;
}

export const vendorService = {
  // Get all vendors with pagination
  getVendors: async (page: number = 1, limit: number = 10): Promise<VendorResponse> => {
    const response = await api.get<VendorResponse>(`/vendor?page=${page}&limit=${limit}`);
    return response.data;
  },

  // Get vendor by ID
  getVendorById: async (id: string): Promise<{ data: Vendor; message: string; error: boolean }> => {
    const response = await api.get<{ data: Vendor; message: string; error: boolean }>(`/vendor/${id}`);
    return response.data;
  },

  // Create vendor
  createVendor: async (vendorData: VendorFormData): Promise<CreateVendorResponse> => {
    const response = await api.post<CreateVendorResponse>('/vendor', vendorData);
    return response.data;
  },

  // Update vendor
  updateVendor: async (id: string, vendorData: VendorFormData): Promise<CreateVendorResponse> => {
    const response = await api.put<CreateVendorResponse>(`/vendor/${id}`, vendorData);
    return response.data;
  },

  // Delete vendor
  deleteVendor: async (id: string): Promise<{ message: string; error: boolean }> => {
    const response = await api.delete<{ message: string; error: boolean }>(`/vendor/${id}`);
    return response.data;
  },
};